export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<dl class="utrecht-data-list utrecht-data-list--html-dl utrecht-data-list--rows">\n  ';
 ctx.util.eachComponent(ctx.components, function(component) { ;
__p += '\n    ';
 if (ctx.isVisibleInRow(component)) { ;
__p += '\n      <div class="utrecht-data-list__item">\n        <dt class="utrecht-data-list__item-key">' +
((__t = ( component.label )) == null ? '' : __t) +
'</dt>\n        <dd class="utrecht-data-list__item-value utrecht-data-list__item-value--html-dd">\n          ' +
((__t = ( ctx.getView(component, ctx.row[component.key]) )) == null ? '' : __t) +
'\n        </dd>\n      </div>\n    ';
 } ;
__p += '\n  ';
 }) ;
__p += '\n</dl>\n\n';
 if (!ctx.self.options.readOnly) { ;
__p += '\n  <p class="utrecht-button-group utrecht-button-group--openforms-editgrid" role="group">\n    <button class="utrecht-button utrecht-button--secondary-action editRow">\n      <i class="' +
((__t = ( ctx.iconClass('edit') )) == null ? '' : __t) +
'"></i>\n    </button>\n    <button class="utrecht-button utrecht-button--primary-action utrecht-button--danger removeRow">\n      <i class="' +
((__t = ( ctx.iconClass('trash-can') )) == null ? '' : __t) +
'"></i>\n    </button>\n  </p>\n';
 } ;
__p += '\n';
return __p
}